import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import {
  BlockHtmlAdapterExtension,
  HastUtils,
} from '@blocksuite/affine-shared/adapters';
import { nanoid } from '@blocksuite/store';

import { createEmbedBlockHtmlAdapterMatcher } from '../../common/adapters/html.js';
import { videoUrlRegex } from '../embed-video-model.js';

export const embedVideoBlockHtmlAdapterMatcher =
  createEmbedBlockHtmlAdapterMatcher(EmbedVideoBlockSchema.model.flavour, {
    toMatch: o => HastUtils.isElement(o.node) && o.node.tagName === 'iframe',
    toBlockSnapshot: {
      enter: (o, context) => {
        if (!HastUtils.isElement(o.node)) {
          return;
        }

        const src = o.node.properties?.src;
        if (typeof src !== 'string') {
          return;
        }

        const { walkerContext } = context;
        if (src.match(videoUrlRegex)) {
          walkerContext
            .openNode(
              {
                type: 'block',
                id: nanoid(),
                flavour: 'affine:embed-video',
                props: {
                  url: src,
                },
                children: [],
              },
              'children'
            )
            .closeNode();
        }
      },
    },
  });

export const EmbedVideoBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  embedVideoBlockHtmlAdapterMatcher
);
